<template>
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <h2>Webcam Live</h2>
                <code v-if="device">{{ device.label }}</code>
                <div class="border">
                    <vue-web-cam
                        ref="webcam"
                        :device-id="deviceId"
                        width="100%"
                        @started="onStarted"
                        @stopped="onStopped"
                        @error="onError"
                        @cameras="onCameras"
                        @camera-change="onCameraChange"
                    />
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <select v-model="camera">
                            <option>-- Webcam auswählen --</option>
                            <option
                                v-for="device in devices"
                                :key="device.deviceId"
                                :value="device.deviceId"
                            >{{ device.label }}</option>
                        </select>
                    </div>
                    <div class="col-md-12">
                        <button type="button" class="btn btn-primary" @click="onCapture">Foto erzeugen</button>
                        <button type="button" class="btn btn-danger" @click="onStop">Webcam ausschalten</button>
                        <button type="button" class="btn btn-success" @click="onStart">Webcam einschalten</button>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <h2>Letztes Foto</h2>
                <figure class="figure">
                    <img :src="img" class="img-responsive" />
                </figure>
                <input type="text" v-model="picReference" />
                <button type="button" class="btn btn-primary" @click="onStore">Speichern</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
	data() {
        return {
            img: null,
            camera: null,
            deviceId: null,
            devices: [],
            picReference: ''
        };
    },
    computed: {
        device: function() {
            return this.devices.find(n => n.deviceId === this.deviceId);
        }
    },
    watch: {
        camera: function(id) {
            this.deviceId = id;
        },
        devices: function() {
            // Once we have a list select the first one
            const [first, ...tail] = this.devices;
            if (first) {
                this.camera = first.deviceId;
                this.deviceId = first.deviceId;
            }
        }
    },
    methods: {
        onCapture() {
            this.img = this.$refs.webcam.capture();
        },
        onStarted(stream) {
            console.log("On Started Event", stream);
        },
        onStopped(stream) {
            console.log("On Stopped Event", stream);
        },
        onStop() {
            this.$refs.webcam.stop();
        },
        onStart() {
            this.$refs.webcam.start();
        },
        onError(error) {
            console.log("On Error Event", error);
        },
        onCameras(cameras) {
            this.devices = cameras;
            console.log("On Cameras Event", cameras);
        },
        onCameraChange(deviceId) {
            this.deviceId = deviceId;
            this.camera = deviceId;
            console.log("On Camera Change Event", deviceId);
        },
        onStore() {
            axios.post('/webcam', { img: this.img.replace(/^data:image\/(png|jpeg);base64,/, ""), ref: this.picReference }).then( response => {
                console.log("Store done");
                this.picReference = "";
                this.img = null;
            }).catch(error => {
                alert("Speichern fehlgeschlagen");
            });
        }
    }
}
</script>
